import { useConditional } from "../core/hooks/useConditional";
import { logoff, useSession } from "../core/hooks/useSession";
import { go } from "../core/route/Route";
import { Icon } from "../core/ui/icons";
import { Notifications } from "../core/ui/Notification";
import { Table } from "../core/ui/Table";
import { isObject } from "../core/utils/conversion";
import { CustomCol, GenericCol } from "../layout/TableCells";
import { LoginModal } from "./auth/LoginModal";
import { RegisterModal } from "./register/RegisterModal";


export function Header(props: {

}) {

	const loginModal = useConditional(() => {
		return (
			<LoginModal
				onClose={loginModal.close}
			/>
		)
	});
	const registerModal = useConditional(() => {
		return (
			<RegisterModal
				onClose={registerModal.close}
			/>
		)
	});

	const session = useSession();

	let loginItems;
	if (session.isAuthenticated()) {
		loginItems = 
			<>
				<button className="transparent" onClick={() => {
					go("/dashboard/");
				}}>
					{session.authToken?.name}
				</button>

				<button className="transparent" onClick={() => {
					logoff();
					go("/");
				}}>Logoff</button>
			</>;
	} else {
		loginItems = 
			<>
				<button className="transparent" onClick={() => {
					registerModal.show({});
				}}>Register</button>
				<button className="transparent" onClick={() => {
					loginModal.show({});
				}}>Login</button>
			</>;
	}

	return (
		<div
			className="flex align-center padding-2 auth-bar"
			style={{backgroundColor:"#000"}}
		>
			<div className="fill"></div>
			<div>
				{loginItems}
				{loginModal.render()}
				{registerModal.render()}
			</div>
		</div>
	);
}

export function Home(props: {

}) {

	const loginModal = useConditional(() => {
		return (
			<LoginModal
				onClose={loginModal.close}
			/>
		)
	});

	function pdfTitleCol(title: string) {
		return {
			title: () => title,
			value: (r: string) => {
				let display = r;
				const toRemove = ["Guardia Corporate - ", "Guardia Legal - "];
				for(let item of toRemove) {
					if (display.startsWith(item)) {
						display = display.substring(item.length);
						break;
					}
				}

				return (
					<div className="flex gap-2">
						<Icon type="document" />
						<a href={"/pdf/" + encodeURIComponent(r + ".pdf")}>{display}</a>
					</div>
				);
			}
		};
	}

	return (
		<div className="home">

			<Notifications />

			<Header />

			<div className="header">
				<img src="/guardia-logo.svg" style={{width:"150px"}} />

				<ul className="menu desktop-only">
					<li className="focused"><a href="/#top">Home</a></li>
					<li><a href="/#about">About</a></li>
					<li><a href="/#whychoose">Why choose us?</a></li>
					<li><a href="/#pricing">Pricing</a></li>
					{/* <li><a href="/#team">Our team</a></li> */}
					<li><a href="/#contact">Contact</a></li>
				</ul>
			</div>

			<div className="hero">
				<div className="message">
					<div className="title">
						Your trusted partner in<br/>company and trust formations
					</div>

					<div className="sub-title margin-top-10">
						<div>Welcome to the Guardia Group, comprising Guardia Corporate and Guardia Legal, where personalised service and expert solutions meet your business needs.  With extensive industry experience and a comprehensive suite of products, we are your trusted partner for:-</div>

						<ul>
							<li>company, trust and smsf formations</li>
							<li>not-for-profit structures,  ACNC registration and advice for charities</li>
							<li>simple through to complex corporate governance services</li>
							<li>legal services which complement our business structure services as well as a broad range of corporate and commercial legal services</li>
						</ul>

					</div>
					{/* <button>
						Learn more
					</button> */}


					
				</div>


			</div>

			<div className="section pad" style={{maxWidth:"800px"}}>
				<div className="flex vert align-start gap-10">
					<div>At Guardia, we provide expertly tailored solutions for company and trust formations, offering a level of personalised service that sets us apart.  Unlike many automated providers, we take the time to understand your specific needs and deliver practical and legally sound solutions that align with your objectives.</div>

					<div>With significant professional experience, we have developed a broad suite of products and services, ensuring you receive efficient, reliable, and compliant business structures.  Whether you’re a lawyer, accountant, financial advisor or business owner, we offer the support and expertise you need to navigate the complexities of company and trust formation with confidence.</div>

					<div>While we use cutting-edge technology to streamline processes, our true focus remains on exceptional service and personalised assistance.  You are never just another transaction—we work closely with you to ensure the best outcomes for you and your clients.</div>

					<div className="flex vert gap-10 align-start" style={{width:"100%"}}>
						<div className="flex horiz align-start" style={{width:"100%"}}>
							<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Personalised Service</h2>
							<div>Tailored solutions for your unique needs.</div>
						</div>
						<div className="flex horiz align-start" style={{width:"100%"}}>
							<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Expertise</h2>
							<div>Decades of industry experience at your service.</div>
						</div>
						<div className="flex horiz align-start" style={{width:"100%"}}>
							<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Comprehensive Suite</h2>
							<div>A full range of products and services to support your business.</div>
						</div>

						<div><i>Phone us to learn more about how we can assist you.</i></div>
					</div>

					<div id="about" />
					
				</div>
			</div>

			<div className="section pad text-inverse"  style={{backgroundColor: "#59ab95"}} >
				<div className="title">
					About Us
				</div>


				<div className="flex vert gap-10 align-start" style={{maxWidth:"800px"}}>
					<h1>Expert Guidance. Tailored Solutions. Unmatched Service.</h1>
					<div>At Guardia, we pride ourselves on providing exceptional service and personalised assistance to each and every client.  With a wealth of experience in this field, we offer practical and legal solutions tailored to your specific needs.  Our team of experts leverages cutting-edge technology to streamline processes and ensure efficient and effective outcomes.</div>
					<div>David Hamley spearheads the Guardia Group.  David gained a very solid footing in the industry, having worked at Castle since 2012.  During that time, David also completed his law degree and is now a fully qualified and experienced lawyer.  David can assist you with any enquiry.</div>
					<div>Noel Beharis is the strength behind the Guardia Group.  He is a much sought-after tax lawyer who carefully and precisely manages the needs of very high net worth individuals and their businesses.</div>
					<div>Lori Gunn started work at Castle in 1998 and has transitioned to the Guardia Group with David.  Lori's expertise straddles the formation of business structures, changes which need to be made to companies and unit trusts and unparalleled knowledge managing foreign companies operating in Australia.  Her accuracy and client service is second to none.</div>
					<div>With years of experience in company and trust formations, Guardia has built a reputation for delivering high-quality, compliant and practical business structures.  Our team is comprised of industry experts who understand the nuances of corporate and trust law, ensuring that every solution we provide is legally robust and commercially viable.</div>
					<div>We stand out from competitors because we offer more than just a formation service—we provide strategic advice and hands-on support throughout the process.  Our commitment to excellence means that every client, regardless of size, receives personalised service tailored to their specific needs.</div>
				</div>

				<div id="whychoose" />

			</div>



			<div className="section pad">
				<div className="title">
					Why Choose Us?
				</div>

				<div className="flex vert gap-10 align-start" style={{maxWidth:"800px"}}>
					<div className="flex horiz align-start">
						<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Personalised Assistance</h2>
						<div>Direct access to experienced professionals who understand your business needs.</div>
					</div>
					<div className="flex horiz align-start">
						<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Comprehensive Product Suite</h2>
						<div>From company registrations to trust formations and compliance services, we cover it all.</div>
					</div>
					<div className="flex horiz align-start">
						<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Legal and Practical Expertise</h2>
						<div>We don’t just process paperwor - we offer solutions that work</div>
					</div>
					<div className="flex horiz align-start">
						<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Service-Focused</h2>
						<div>Advanced digital tools backed by real human support.  While we leverage great technology to streamline processes and enhance efficiency, our primary focus is always on service and personalised assistance.  We believe that technology should support our commitment to exceptional client service, not replace it</div>
					</div>
					<div className="flex horiz align-start">
						<h2 style={{flexBasis:"25vw", flexShrink: "0"}}>Industry Experience</h2>
						<div>Decades of combined knowledge ensure precision, compliance, and efficiency.  With significant industry experience, we bring a wealth of knowledge and expertise to everything we do.  Our years of experience enable us to navigate complex legal and regulatory landscapes with ease, ensuring you receive the best possible advice and support.</div>
					</div>


					<h3>
						Whether you're looking to register a company, create a trust, or need assistance with corporate compliance, we have a full suite of products and services designed to support you.  We're here to ensure that every product or service provided to you exceeds your expectations and is both legally perfect and designed for its purpose.
					</h3>

					<div>
						At Guardia, we believe that great service is just as important as great technology.  Let us help you establish and manage your business structures with confidence and ease.  Every client is unique, and so are their needs.  We take pride in offering a highly personalised service delivered by experienced experts, in Australia, who excel at finding practical and legal solutions tailored to meet your objectives.
					</div>

					<div>
						Your satisfaction with our work is our priority.   We invite you to talk with us, obligation free, about any requirement you have to satisfy yourself that you will receive the level of expertise and attention that you deserve.
					</div>

					<div id="pricing" />

				</div>
			</div>


			<div className="section pad" style={{backgroundColor: "#fef8f1"}} >
				<div className="title">
					Pricing
				</div>

				<div className="flex vert gap-10 align-start padding-right-20">

					<div className="flex horiz gap-20 align-start grow-children">
						<div>
							<h1>Guardia Corporate</h1>

							<div className="padding-left-10 flex vert gap-10">
								<Table
									cols={[
										CustomCol(pdfTitleCol("Pricing")),
									]}
									items={[
										"Guardia Corporate - Price List 2024-25",
									]}
								/>

								<Table
									cols={[
										CustomCol(pdfTitleCol("Order forms")),
									]}
									items={[
										"Guardia Corporate - ABN Order Form (Short)",
										"Guardia Corporate - ABN Order Form",
										"Guardia Corporate - Adoption Order Form",
										"Guardia Corporate - Association Order Form",
										"Guardia Corporate - Business Name Change to Details Order Form",
										"Guardia Corporate - Business Name Order Form",
										"Guardia Corporate - Capital Reduction",
										"Guardia Corporate - Change of Status Order Form",
										"Guardia Corporate - Company Change of Name Order Form",
										"Guardia Corporate - Company Limited by Guarantee Order Form",
										"Guardia Corporate - Company Order Form and Schedule A",
										"Guardia Corporate - Company Order Form",
										"Guardia Corporate - Company Package Comparison",
										"Guardia Corporate - Corporate Registry Services Order Form",
										"Guardia Corporate - Deregistration Order Form",
										"Guardia Corporate - Discretionary Trust Order Form",
										"Guardia Corporate - DT Package Comparison",
										"Guardia Corporate - Foreign Registered Company Order Form",
										"Guardia Corporate - Hybrid Unit Trust Order Form",
										"Guardia Corporate - Self Managed Super Fund Order Form",
										"Guardia Corporate - SMSF Package Comparison",
										"Guardia Corporate - Unit Trust Order Form",
										"Guardia Corporate - UT Package Comparison",
									]}
								/>
							</div>
						</div>

						<div>
							<h1>Guardia Legal</h1>

							<div className="padding-left-10 flex vert gap-10">
								<Table
									cols={[
										CustomCol(pdfTitleCol("Pricing")),
									]}
									items={[
										"Guardia Legal - Price List 2024-25",
									]}
								/>

								<Table
									cols={[
										CustomCol(pdfTitleCol("Order forms")),
									]}
									items={[
										"Guardia Legal - Bare Trust Order Form",
										"Guardia Legal - Division 7A Loan Order Form",
										"Guardia Legal - DT Change of Trustee Order Form",
										"Guardia Legal - DT Variation Order Form",
										"Guardia Legal - DT Vesting Order Form",
										"Guardia Legal - Pension Kit Order Form",
										"Guardia Legal - SMSF Change of Trustee Order Form",
										"Guardia Legal - SMSF Variation Order Form",
										"Guardia Legal - SMSF Vesting Order Form",
										"Guardia Legal - Special Disability Trust Order Form",
										"Guardia Legal - UT Change of Trustee Order Form",
										"Guardia Legal - UT Variation Order Form",
										"Guardia Legal - UT Vesting Order Form",
									]}
								/>
							</div>

						</div>

						<div>
							<h1>General Forms</h1>

							<div className="padding-left-10 flex vert gap-10">
								<Table
									cols={[
										CustomCol(pdfTitleCol("Card Authorisation")),
									]}
									items={[
										"Guardia Business Group - Credit Card Authorisation - 2024-08",
										"Guardia Business Group - Enduring Credit Card Authorisation - 2024-08",
									]}
								/>
							</div>
						</div>

					</div>

					<div id="contact" />

				</div>
			</div>


			{/* <div className="section pad" id="products">
				<div className="title">
					Products
				</div>

				<div className="products">
					<div className="product">
						<div className="title">Companies</div>
						<div className="desc">Description</div>
					</div>
					<div className="product">
						<div className="title">Trust & Super Funds</div>
						<div className="desc">Description</div>
					</div>
					<div className="product">
						<div className="title">More</div>
						<div className="desc">Description</div>
					</div>
				</div>
			</div>

			<div className="section pad" style={{backgroundColor: "#fef8f1"}} id="team">
				<div className="title">
					Our team
				</div>

				<div className="products">
					<div className="product person">
						<div className="photo"></div>
						<div className="title">David Hamley</div>
						<div className="desc">Lawyer</div>
					</div>
					<div className="product person">
						<div className="photo"></div>
						<div className="title">Noel Beharis</div>
						<div className="desc">Lawyer</div>
					</div>
				</div>

			</div>
 */}
			<div className="section pad text-inverse" style={{backgroundColor: "#59ab95"}}>
				<div className="title">
					Contact us
				</div>
				<div className="sub-title">Let us know how we can help you</div>
				<div>Further text</div>
			</div>

			<div
				className="abg-brand-secondary padding-5 text-center"
				style={{
					boxShadow: "inset 0 15px 15px rgba(0,0,0,0.2)",
					padding: "40px 0 60px 0"
				}}
			>
				<div>&copy; 2025 Guardia Corporate   ABN 99 674 678 089</div>
				<div>Suite 11, Ground Floor, 2 Brandon Park Drive, Wheelers Hill 3150</div>
				<div>T: 03 8544 1000   E: <a href="mailto:admin@guardiacorp.com.au">admin@guardiacorp.com.au</a></div>
			</div>

			{loginModal.render()}

		</div>
	);
}
